import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { formatText } from "bernie-l10n";
import { LobMobileTitleProps, TitleProps } from "./typings";

const Title: React.FunctionComponent<TitleProps> = ({ title }) => (
  <div className="uitk-grid all-b-padding-three">
    <h1 className="uitk-cell uitk-type-heading-600">{title}</h1>
  </div>
);

export const LobMobileTitle: React.FunctionComponent<LobMobileTitleProps> = ({ lobState }) => {
  const title = formatText(lobState.config.heading.mobileLocToken);

  // fixedTitle from the lob config takes precedence over the default behavior of the title
  if (lobState.config.heading.fixedTitle) {
    return <Title title={title} />;
  }

  return (
    <Viewport>
      <ViewSmall>
        <Title title={title} />
      </ViewSmall>
      <ViewMedium />
    </Viewport>
  );
};
